import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import useHasPermission from 'hooks/useHasPermission';

import { useGetUsageBillingEnabled } from './useGetUsageBillingEnabled';

export function useHasBillingAccess(): boolean {
  return useHasPermission(PERMISSIONS.billing_read);
}

/**
 * Returns true when billing data can be safely fetched: the usage billing
 * feature flag is enabled AND the current user has `billing_read` permission.
 *
 * Use this to gate `enabled` on billing API query hooks so we don't fire
 * requests that would 403 on the backend for users without billing access.
 *
 * Do NOT use this for feature-flag-only decisions (e.g. deciding which UI
 * branch to render based on usage billing being enabled) — those should use
 * `useGetUsageBillingEnabled()` directly so they aren't coupled to the
 * billing_read permission.
 */
export function useCanFetchBillingData(): boolean {
  const usageBillingEnabled = useGetUsageBillingEnabled();
  const hasBillingAccess = useHasBillingAccess();
  return usageBillingEnabled && hasBillingAccess;
}
